import React, {Component} from 'react';
import Markdown from './markdown';

export default class Convo extends Component {
  renderTextMessage(message) {
    let class_name=`message ${message.role}_message`
    return (
      <div className={class_name}>
        {/* <p className="role">{message.role}:</p> */}
        <Markdown text={message.content} />
      </div>
    )
  }

  renderFileMessage(message) {
    return (
      <div className="file message user_message">
        {message.content.map((file, index)  => {
          return <p key={index}><span  className="fa fa-paperclip"></span> <a download={file.filename} href={file.file_data} >{file.filename}</a></p>
        })}
      </div>
    )
  }

  renderDebugMessage(message) {
    let class_name=`message ${message.role}_message`
    let content;

    if (message.format === 'json') {
      let data = JSON.parse(message.content);
      if (Array.isArray(data.content)) {
        return this.renderFileMessage(data);
      }
    }


    if (typeof message.content === 'string' || message.content instanceof String) {
      content = message.content;
    } else {
      content = JSON.stringify(message.content, null, 2);
    }

    return (
      <div className={class_name}>
        <p className="role">{message.role} <strong>[DEBUG]</strong>:</p>
        <pre>{content}</pre>
      </div>
    )
  }


  renderMessage(message) {
    if (Array.isArray(message.content) && message.content[0].type === 'input_file') {
      return this.renderFileMessage(message);
    } else if (message.debug) {
      return this.renderDebugMessage(message);
    } else {
      return this.renderTextMessage(message);
    }
  }

  renderTimeStamp(message) {
    if (!message.ts) return null;
    let date = new Date(message.ts * 1000);
    let date_str = moment(date).format('lll');
    return <span className="timestamp">{date_str}</span>
  }

  renderDots() {
    let {show_waiting, current_node} = this.props;
    if (!show_waiting) return null;

    let message;
    if (current_node && current_node.loading_text) {
      message = current_node.loading_text;
    } else{
      message = 'Processing';
    }
    return (
      <div className="dots">{message} <p className="loading-dots"></p></div>
    )
  }

  render() {
    let {convo} = this.props;
    return (
      <div id="convo">
        {convo.map((message, index) => {
          let class_name=`message_container ${message.role}_message_container`
          return (
            <div key={index} className={class_name}>
              {this.renderMessage(message)}
              {this.renderTimeStamp(message)}
            </div>

          )
        })}

        {this.renderDots()}
      </div>
    );

  }
}
